import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Flex, Image, Text, rem } from '@mantine/core';
import styles from './Bunker.module.css';
import { BunkerEquipSection } from './BunkerEquipSection';
export const BunkerMainSection: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Flex direction="column" gap={{
    base: 32,
    sm: 0
  }}>
      <Text ta="center" pt={2} style={{
      textWrap: 'nowrap'
    }} fz={{
      base: 48,
      sm: 56,
      lg: 73
    }} className={gunterzBold.className} classNames={{
      root: styles.text
    }} lh={{
      base: rem(48),
      sm: rem(56),
      lg: rem(73)
    }}>
        {i18n._('THE BUNKER')}
      </Text>

      <BunkerEquipSection hiddenFrom="sm" />

      <Image mt={{
      sm: 10,
      lg: -65
    }} mx="auto" src="/assets/bunker/bunker-cat-character.png" alt="bunker character" maw={485} />
    </Flex>;
};